import { FC, useEffect, useState } from "react";
import { Table } from "antd";
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/es/table";
import { useVrmMaintenanceDetailsModel } from "../vrmBillMaintenanceRoModel";
import { RouterParamType } from "@/model/navModel";
import { ReturnItemList } from "../vrmBillMaintenanceRoType";
import zeng from "@/assets/images/zeng.png"


// 商品属性
const ItemAttr = new Map([
    ["import", "进口"],
    ["domestic", "国产"],
]);
export const ItemTableBox: FC<RouterParamType> = ({ id, mode }) => {
    const { itemDetail } = useVrmMaintenanceDetailsModel();
    const [totalPrice, setTotalPrice] = useState<string>("0");

    const title = <>
        <span>维修项目</span>
        <span style={{ marginLeft: '50px', fontSize: '14px' }}>
            总金额&nbsp;¥&nbsp;<span style={{ color: 'red', fontSize: '18px' }}>{totalPrice}</span>
            &nbsp;元&nbsp;({itemDetail.length}项){" "}
        </span>
    </>

    //计算总价
    useEffect(() => {
        let num: number = 0
        itemDetail.forEach((item) => {
            num += Number(item.actualAmount)
        })
        setTotalPrice(num.toFixed(2));
    }, [itemDetail])

    const itemColumn: ColumnsType<ReturnItemList> = [
        {
            title: '序号',
            width: 40,
            align: "center",
            render: (t: any, r: any, i: number) => <>{i + 1}</>
        }, {
            title: "项目编码",
            align: "center",
            width: 120,
            dataIndex: "itemCode",
        },
        {
            title: "项目名称",
            align: "center",
            width: 300,
            dataIndex: "itemName",
        },
        {
            title: "预付款",
            align: "center",
            width: 80,
            dataIndex: "prepayFlag",
            render: (text) => (text == 0 ? "否" : "是"),
        },
        {
            title: "项目属性",
            align: "center",
            width: 120,
            dataIndex: "itemAttr",
            render: (text) => <p>{ItemAttr.get(text)}</p>,
        },
        {
            title: "工时",
            align: "center",
            width: 80,
            dataIndex: "itemWorkHours",
        },
        {
            title: "单价",
            align: "center",
            width: 80,
            dataIndex: "workHoursPrice",
        },
        {
            title: "工时费",
            align: "center",
            width: 80,
            dataIndex: "itemAmount",
        },
        {
            title: "优惠",
            align: "center",
            width: 80,
            dataIndex: "preferentialAmount",
        },
        {
            title: "折扣",
            align: "center",
            width: 80,
            dataIndex: "itemDiscount",
        },
        {
            title: "总金额",
            align: "center",
            width: 80,
            dataIndex: "actualAmount",
        },
        {
            title: "是否赠送",
            align: "center",
            width: 100,
            dataIndex: "giftFlag",
            render: (text) => (text === "gift" ? <img src={zeng} style={{ width: "35px" }} alt="" /> : ""),
        },
        {
            title: "备注",
            align: "center",
            width: 200,
            dataIndex: "remark",
        },
    ];
    return (
        <YhBox title={title} style={{ marginBottom: "5px" }}>
            <Table
                rowKey={record => record.id as string}
                rowClassName='editable-row yh-edit-table-tr'
                columns={itemColumn}
                dataSource={itemDetail}
                pagination={false}
                scroll={{ x: 'max-content', y: 250 }}
            />
        </YhBox>
    )
}